import React, { Component } from "react";
import { Button, Container, Card, CardBody } from "react-bootstrap";

import CardWithImageComponent from "../components/CardWithImageComponent.js";
import { applyNavigationEffect } from "../effects/NavigationEffect.js";

import Beitrittserklaerung from "../assets/files/BVH_Beitrittserklaerung.pdf";

class BecomeMember extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    applyNavigationEffect();
  }

  render() {
    return (
      <div id="become-member" className="webpage">
        <Container className="main-container">
          <Card>
            <Card.Header>Mitglied werden</Card.Header>
            <Card.Body>
              Wenn Du Dich irgendwo in den folgenden Punkten wieder findest
              solltest Du Dir die Frage stellen, ob Du uns durch Deine
              Mitgliedschaft unterstützen könntest: <br /> <br />
              <ul>
                <li>Du hast Interesse an der Zeit des Hochmittelalters</li>
                <li>
                  Du interessierst Dich für regionale Geschichte (in Dautphetal,
                  Biedenkopf, Hinterland)
                </li>
                <li>
                  Du möchtest regionale Kultur und Geschichte unterstützen
                </li>
                <li> Du bist in Dautphetal oder Biedenkopf verwurzelt</li>
                <li>
                  {" "}
                  Du möchtest ein 775 Jahre altes Kellergewölbe vor dem Einsturz
                  bewahren helfen
                </li>
                <li> Du findest die Indiana Jones Filme prima! 😉</li>
                <li> Du hast Entdeckergeist und Phantasie</li>
                <li> Du möchtest dich ehrenamtlich engagieren</li>
                <li>
                  {" "}
                  Du möchtest dich nicht ehrenamtlich engagieren aber durch die
                  Mitgliedschaft an sich deinen Beitrag leisten
                </li>
              </ul>
              <br />
              Um die Ziele des Vereins zu erreichen, brauchen wir mehr von Euch!{" "}
              <br />
              In den Mitgliedszahlen spiegelt sich zum Teil auch das öffentliche
              Interesse wider. <br />
              Auch eine rein passive Mitgliedschaft freut uns (siehe Auswahlfeld
              im Antrag) und hilft dem Vorstand die zuständigen Einrichtungen
              von uns und unseren Vorhaben zu überzeugen! <br />
              Der Beitrag liegt mit 12,50€ pro Jahr im überschaubaren Bereich.{" "}
              <br />
              Kinder, Schüler und Studenten sind zudem von der Beitragspflicht
              befreit.
              <br />
              Wenn Du Dich mit unseren Aufgaben und Zielsetzung identifizieren
              kannst, werde Mitglied! <br />
              Gemeinsam sind wir stärker als allein!
              <br />
              Entgegen dem Eindruck, dass Vereine nicht gerade im Trend der Zeit
              sind, können wir einen jährlichen Mitgliederzuwachs von etwa 25%
              verzeichnen. <br />
              Wir sind sehr dankbar für das uns entgegengebrachte Vertrauen und
              sind gut aufgestellt und organisiert, um diesem Gerecht zu werden.
              <br />
              Wir sind in persönlichen Gesprächen immer wieder überrascht
              darüber, Wieviele unsere Sache gut finden. <br />
              Eine Resonanz ist gerade im Ehrenamt wichtig, um motiviert zu
              bleiben und um gemeinsam neue Ideen zu entwickeln, letztendlich
              auch um zu wissen was ankommt.
              <br />
            </Card.Body>
          </Card>
          <CardWithImageComponent
            image="assets/images/general_images/beitritt.png"
            header="Mitglied werden"
            className="card-with-image"
            id="become-member-card"
            content={
              <div>
                <a
                  style={{ display: "flex", justifyContent: "center" }}
                  href={Beitrittserklaerung}
                  download="BVH_Beitrittserklaerung"
                  target="_blank"
                >
                  <Button className="btn btn-primary">Zum Antrag</Button>
                </a>
              </div>
            }
          />
          <Card id="datenschutz-mitglieder">
            <Card.Header>Datenschutz Mitgliedsantrag</Card.Header>
            <Card.Body>
              <b>
                Datenschutzhinweis des Burgvereins Hohenfels e.V. nach Art. 12,
                13 und 14 DS-GVO
              </b>
              <p>
                Im Folgenden erhalten Sie die nach Art. 12, 13 und 14 DS-GVO
                notwendigen Informationen, die der Verantwortliche einer
                betroffenen Person, d.h. einer Person, deren personenbezogene
                Daten er verarbeitet, gemäß den vorgenannten Artikeln bereit zu
                stellen hat. Personenbezogene Daten sind alle Informationen, die
                sich auf eine bestimmte oder bestimmbare Person beziehen.
              </p>
              <p>
                A) Verantwortlicher für die Datenverarbeitung ist der Burgverein
                Hohenfels e. V., gesetzlich vertreten durch seinen
                geschäftsführenden Vorstand. Den Verantwortlichen können Sie
                unter folgenden Kontaktdaten erreichen: Im Steinfeld 19, 35232
                Dautphetal, E-Mail-Adresse: burg.hohenfels@gmail.com{" "}
              </p>
              <p>
                B) Datenschutzbeauftragter: Der Verein hat keinen
                Datenschutzbeauftragten benannt und ist hierzu nach den
                gesetzlichen Bestimmungen nicht verpflichtet.
              </p>
              <p>
                C) Zwecke, Rechtsgrundlage und Folgen der Nichtbereitstellung
              </p>
              <ol>
                <li>
                  Mitgliederverwaltung und -betreuung Ihre personenbezogenen
                  Daten (z.B. Titel, Vorname, Nachname, Geburtsdatum,
                  Postanschrift, Telefonnummern, E-Mail-Adresse,
                  Mitgliedsnummer, Ein- bzw. Austrittsdatum, Bankverbindung,
                  Funktionen im Verein) werden für die Begründung, Durchführung
                  und Beendigung des Mitgliedschaftsverhältnisses (z.B.
                  Mitgliederbetreuung, Beitragseinzug, Organisation von
                  Veranstaltungen, Kommunikation) verarbeitet. Rechtsgrundlage
                  ist Art. 6 Abs. 1 Buchstabe b) DS-GVO. Sofern dem
                  Verantwortlichen gegenüber zu diesem Zweck weitere freiwillige
                  Angaben gemacht werden (z.B. Beruf, Telefaxnummer, Homepage)
                  verarbeitet der Verein die personenbezogenen Daten aufgrund
                  Ihrer Einwilligung gem. Art. 6 Abs. 1 Buchstabe a), Art. 7, 9
                  Abs. 2 Buchstabe a), DS-GVO. Werden für die Begründung oder
                  Fortführung der Mitgliedschaft notwendige Angaben (z.B. Name,
                  Postanschrift) nicht gemacht, kann eine Mitgliedschaft nicht
                  begründet oder fortgesetzt werden.
                </li>
                <li>
                  Förderung des Vereinszwecks Darüber hinaus verarbeitet der
                  Verein personenbezogene Daten, um im Sinne des Vereinszwecks
                  (§2 der Vereinssatzung) tätig zu sein. Hierzu zählen Daten,
                  Fotografien, Forschungsergebnisse, Veröffentlichungen,
                  Vortragsveranstaltungen. Diese werden auch zur Förderung des
                  Austauschs und Pflege der Beziehungen zu Vereinigungen die im
                  Bereich der historischen und verwandten Wissenschaften
                  verwendet. Rechtsgrundlage für die Verarbeitung ist Art. 6
                  Abs. 1 Buchstabe f) DSGVO. Die Verarbeitung von
                  personenbezogenen Daten im Rahmen des Vereinszwecks begründet
                  ein berechtigtes Interesse an der Datenverarbeitung.
                </li>
                <li>
                  Öffentlichkeitsarbeit Außerdem werden personenbezogene Daten
                  (z.B. Fotografien) insbesondere im Zusammenhang mit
                  Veranstaltungen einschließlich der Berichterstattung hierüber
                  zur Öffentlichkeitsarbeit auf der Internetseite des Vereins
                  sowie in Auftritten des Vereins in Sozialen Medien
                  veröffentlicht und an lokale, regionale und überregionale
                  Printmedien im Rahmen der gesetzlichen Vorschriften
                  übermittelt. Die Rechtsgrundlage der Verarbeitung ist Art. 6
                  Abs. 1 Buchstabe f), bzw. Art. 6 Abs. 1 Buchstabe a), Art. 9
                  Abs. 2 Buchstabe a) DS-GVO bzw. §§ 22ff. KunstUrhG. Das
                  berechtigte Interesse des Vereins besteht in der Information
                  der Öffentlichkeit und der übrigen Vereinsmitglieder durch
                  Berichterstattung über die Aktivitäten des Vereins. Der
                  Widerspruch oder der Widerruf der Einwilligung lässt das
                  Mitgliedschaftsverhältnis unberührt.
                </li>
              </ol>
              <p>D) Empfänger der personenbezogenen Daten </p>
              <p>
                Der Verein setzt folgende Dienstleister als Auftragsverarbeiter
                (Art. 28 DS-GVO) ein, an welche personenbezogene Daten
                übermittelt werden: IT-Dienstleister im Rahmen der
                Datensicherung, der Mitgliederverwaltung, des E-Mailverkehrs,
                des Newsletterversands und der IT-Wartung sowie Dienstleister
                zur Durchführung des Versands der Vereinszeitschrift. Zudem
                übermittelt der Verein personenbezogene Daten im Rahmen der
                datenschutzrechtlichen Bestimmungen und soweit dies erforderlich
                ist an eine Steuerberaterkanzlei zur Durchführung von
                Buchhaltungsaufgaben (Art. 6 Abs. 1 Buchstabe f) DS-GVO), und an
                Kreditinstitute zum Zwecke des Beitragseinzugs (Art. 6 Abs. 1
                Buchstabe b) DS-GVO). Personenbezogene Daten auf der
                Internetseite sind der Allgemeinheit zugänglich und daher
                grundsätzlich von jedermann einsehbar. Darüber hinaus findet
                eine Weitergabe von Daten an Dritte grundsätzlich nicht statt.
                Der Verein verarbeitet personenbezogene Daten nicht außerhalb
                der EU und des europäischen Wirtschaftsraumes (EWR) und gibt
                Daten auch nicht an Dritte außerhalb der EU und des Europäischen
                Wirtschaftsraums weiter.
              </p>
              <p>E) Speicherdauer</p>
              <p>
                Die personenbezogenen Daten werden jedenfalls für die Dauer der
                Mitgliedschaft gespeichert. Im Regelfall werden die Daten danach
                für mindestens weitere 3 Jahre aufbewahrt. Dies entspricht der
                regelmäßigen Verjährungsfrist des Bürgerlichen Gesetzesbuches
                (BGB). Eine darüber hinausgehende Speicherung erfolgt, wenn der
                Verein aufgrund von steuer- und handelsrechtlichen
                Aufbewahrungs- und Dokumentationspflichten (aus HGB, StGB oder
                AO) zu einer längeren Speicherung verpflichtet ist (Art. 6 Abs.
                1 S. 1 Buchstabe c) DS-GVO), Sie in eine darüber hinausgehende
                Speicherung eingewilligt haben (Art. 6 Abs. 1 S. 1 Buchstabe a),
                Art. 9 Abs. 2 Buchstabe a) DS-GVO) oder einer Löschung sonstige
                berechtigte Interessen (z.B. längere Verjährungsfristen)
                entgegenstehen (Art. 6 Abs. 1 S. 1 Buchstabe f), Art. 7, Art. 9
                Abs. 2 Buchstabe f) DS-GVO). In der Zeit zwischen Beendigung der
                Mitgliedschaft und der Löschung wird die Verarbeitung dieser
                Daten eingeschränkt. Bestimmte Datenkategorien werden jedoch zum
                Zweck der Vereinschronik im Vereinsarchiv gespeichert und daher
                nicht gelöscht. Hierbei handelt es sich um die Kategorien
                Vorname, Nachname, Zeitraum der Zugehörigkeit zum Verein und
                besondere Ereignisse, an denen die betroffene Person mitgewirkt
                hat. Der Speicherung liegt ein berechtigtes Interesse des
                Vereins an der zeitgeschichtlichen Dokumentation von Ereignissen
                und Erfolgen zugrunde (Art. 6 Abs. 1 S. 1 Buchstabe f) DS-GVO).
              </p>
              <p>F) Rechte der betroffenen Person</p>
              <p>
                Sie haben gegenüber dem Verein folgende Rechte: –Recht auf
                Auskunft gemäß Art. 15 DS-GVO, –Recht auf Berichtigung oder
                Löschung gemäß Art. 16 DS-GVO bzw. Art .17 DS-GVO, –Recht auf
                Einschränkung der Verarbeitung gemäß Art. 18 DS-GVO, –Recht auf
                Widerspruch gegen die Verarbeitung gemäß Art. 21 DS-GVO, –Recht
                auf Datenübertragbarkeit gemäß Art. 20 DS-GVO. Sie haben zudem
                gem. Art. 77 DS-GVO das Recht, sich bei einer
                Datenschutz-Aufsichtsbehörde über die Verarbeitung Ihrer
                personenbezogenen Daten durch den Verein zu beschweren. In der
                Regel können Sie sich hierfür an die Aufsichtsbehörde Ihres
                üblichen Aufenthaltsortes oder Arbeitsplatzes oder des
                Vereinssitzes wenden. Am Vereinssitz ist der Hessische
                Beauftragte für Datenschutz und Informationsfreiheit, Postfach
                3163, 65021 Wiesbaden, die zuständige Aufsichtsbehörde. Soweit
                Sie eine Einwilligung zur Verarbeitung Ihrer personenbezogenen
                Daten erteilt haben, können Sie gem. Art. 7 DS-GVO Ihre einmal
                erteilte Einwilligung jederzeit in Textform (Brief, E-Mail)
                widerrufen. Dies hat zur Folge, dass wir die Datenverarbeitung,
                die auf dieser Einwilligung beruhte, für die Zukunft nicht mehr
                fortführen dürfen. Wir behalten uns jedoch vor, die Verarbeitung
                der personenbezogenen Daten fortzuführen, wenn eine gesetzliche
                Erlaubnisnorm dies gestattet. Die Verarbeitung der
                personenbezogenen Daten in der Vergangenheit wird durch den
                Widerruf der Einwilligung nicht berührt. Sofern Ihre
                personenbezogenen Daten auf Grundlage von berechtigten
                Interessen gemäß Art. 6 Abs. 1 S. 1 Buchstabe f) DS-GVO
                verarbeitet werden, haben Sie das Recht, gemäß Art. 21 DS-GVO
                Widerspruch gegen die Verarbeitung Ihrer personenbezogenen Daten
                einzulegen, soweit dafür Gründe vorliegen, die sich aus Ihrer
                besonderen Situation ergeben oder sich der Widerspruch gegen
                Direktwerbung richtet.
              </p>
              <p>G) Quellen</p>
              <p>
                Die personenbezogenen Daten werden unmittelbar von Ihnen oder im
                Rahmen der Tätigkeit des Vereins erhoben.
              </p>
              <p>H) Aktualisierungen der Information</p> 
              <p>Diese Datenschutzerklärung ist
              aktuell gültig und hat den Stand 15.05.2025. Insbesondere aufgrund
              geänderter gesetzlicher, beziehungsweise behördlicher Vorgaben
              kann es notwendig werden, diese Datenschutzerklärung zu ändern.
              Der Verein behält sich daher vor, diese Erklärung jederzeit
              anzupassen. Aktualisierte Fassungen stellt der Verein auch auf
              Anfrage gerne zur Verfügung. <br/><br/>
              Burgverein Hohenfels e.V. 15.05.2025</p>
            </Card.Body>
          </Card>
        </Container>
      </div>
    );
  }
}

export default BecomeMember;
